module.exports = __webpack_public_path__ + "static/media/image02.b9d8a677.png";